import React from 'react'
import {ExtendMetaData, ExtendMetaDataInputInfo, ExtendMetaDataItem} from '../../../../DTO/ExtendMetaDataDTO'
import {PIMCard} from '../../../Atoms/Cards/PIMCard'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'
import {MBContentSubTitleTypography} from '../../../Atoms/Typographies'
import {MBMemberSelect} from '../../../Atoms/MBMemberSelect'
import {MBMemberInput} from "../../../Atoms/MBMemberInput"
import {MBContentBodyDivider} from '../../../Atoms/Dividers'
import {MBRequiredBadge} from '../../../Atoms/Badges'
import {RowFlexContainer} from '../../../../../Admins/Views/Atoms/Containers'
import {Optional} from '../../../../../Common/TypeHelper'
import {ExtendMetaDataErrors} from '../../../../Utils/Validations/ValidateMembersSignupInput'
import {ErrorDisplay} from '../../../Molecules/ErrorsAndAlert/ErrorDisplay'

type ExtendMetaDataInputBlockProps = {
  extendMetaData: ExtendMetaData[]
  extendMetaDataInputState: ExtendMetaDataInputInfo
  setExtendMetaDataInputState: (inputInfo: ExtendMetaDataInputInfo) => void
  errorMessages: Optional<ExtendMetaDataErrors>
}

export const ExtendMetaDataInputBlock: React.VFC<ExtendMetaDataInputBlockProps> = (
  {
    extendMetaData,
    extendMetaDataInputState,
    setExtendMetaDataInputState,
    errorMessages,
  },
) => {
  return <>{extendMetaData.map(({header, items, description}, idx) =>
    <PIMCard
      headerProps={{
        title: header,
        require: items.length === 1 && items[0].required,
      }}
      key={idx}
      testId={`block-extend-meta-data-${idx}`}
    >
      <PIMStack
        spacing={'18px'}
        divider={<MBContentBodyDivider/>}
        showEndDivider
      >
        {description && <MBContentSubTitleTypography>{description}</MBContentSubTitleTypography>}
        {items.map(item =>
          <PIMStack
            spacing={'6px'}
            key={item.id}
            testId={`input-area-${item.id}`}
          >
            {items.length > 1 &&
              <RowFlexContainer gap={'6px'}>
                <label htmlFor={item.id}>
                  <MBContentSubTitleTypography>{item.label}</MBContentSubTitleTypography>
                </label>
                {item.required && <MBRequiredBadge/>}
              </RowFlexContainer>
            }
            <div>
              <TypeInputForm
                itemInfo={item}
                itemState={extendMetaDataInputState[item.id]}
                onChange={(value): void => setExtendMetaDataInputState({
                  ...extendMetaDataInputState,
                  [item.id]: value,
                })}
                hasError={getError(errorMessages, item.id).length > 0}
              />
              <ErrorDisplay errors={getError(errorMessages, item.id)}/>
            </div>
          </PIMStack>,
        )
        }
      </PIMStack>
    </PIMCard>,
  )}</>
}

const getError = (errors: Optional<ExtendMetaDataErrors>, itemId: string): string[] => {
  if (errors === undefined) {
    return []
  }

  return errors[itemId] ?? []
}

type TypeInputFormProps = {
  itemInfo: ExtendMetaDataItem
  itemState: number | string | undefined
  onChange: (value: number | string) => void
  hasError: boolean
}
const TypeInputForm: React.VFC<TypeInputFormProps> = (
  {itemInfo, itemState, onChange, hasError},
) => {
  switch (itemInfo.type) {
    case 'singleSelect':
      return (
        <MBMemberSelect
          id={itemInfo.id}
          value={itemState}
          hasError={hasError}
          onChange={(e): void => onChange(Number(e.target.value))}
        >
          <option className="placeholder" value="" hidden>選択してください</option>
          {itemInfo.options.map(option =>
            <option key={option.id} value={option.id}>{option.label}</option>,
          )}
        </MBMemberSelect>
      )
    case 'singleText':
      return (
        <MBMemberInput
          id={itemInfo.id}
          value={itemState}
          className="form-text_01 w_100 pc100"
          hasError={hasError}
          onChange={(e): void => onChange(e.target.value)}
        />
      )
    default:
      return <></>
  }
}
